/// <reference path="../typings/index.d.ts" />
namespace App {
    export class Configuracao {
        private ajax: IAjax;
        public executarCallbackChange: any = null;
        private elSilenciarSniper: JQuery = $("input[name=modo_silencioso]");
        private elAtivarModoHumano: JQuery = $("#ativarModoHumano");

        public constructor() {
            this.ajax = new App.Ajax();
            this.elSilenciarSniper.on('change', (e) => { this.aoSelecionarModoSilencioso(e); })
            this.elAtivarModoHumano.on('change', (e) => { this.aoSelecionarModoHumano(e); });
        }

        public setConfiguracoes(dadosConfiguracoes: IConfiguracaoUsuario) {
            this.elSilenciarSniper.prop("checked", Boolean(dadosConfiguracoes.modo_silencioso));
        }

        private aoSelecionarModoSilencioso(e: JQueryEventObject) {
            this.ajax.postAcaoSemResposta($(e.target).data('url'), { modo_silencioso: $(e.target).is(':checked') });
            if (this.executarCallbackChange) {
                this.executarCallbackChange({ modo_silencioso: $(e.target).is(':checked') });
            }
        }

        private aoSelecionarModoHumano(e: JQueryEventObject) {
            if ($(e.target).is(':checked')) {
                this.ajax.postAcaoSemResposta($(e.target).data('url'), { modo_humano: $(e.target).is(':checked') });
                if (this.executarCallbackChange) {
                    this.executarCallbackChange({ modo_humano: $(e.target).is(':checked') });
                }
            } else {
                swal({
                    title: 'Tem certeza disso?',
                    text: "O modo humano é uma forma de deixar as ações do FUTSNIPERWEB menos robótica para evitar despertar a atenção da EA em sua conta",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#db7250',
                    cancelButtonColor: '#2dce89',
                    confirmButtonText: 'Sim, quero mais liberdade',
                    cancelButtonText: "manter ativo"
                }).then((result: any) => {
                    if (result.value) {
                        this.ajax.postAcaoSemResposta($(e.target).data('url'), { modo_humano: false });
                    } else {
                        $(e.target).prop("checked", true);
                    }

                    if (this.executarCallbackChange) {
                        this.executarCallbackChange({ modo_humano: $(e.target).is(':checked') });
                    }
                })
            }
        }
    }
}
